const rootPath = window.Shopify?.routes?.root || '/';
let drawerTrigger = null;

function selectGalleryImage(gallery, id) {
  if (!gallery?.querySelector(`[data-gallery-image="${CSS.escape(id)}"]`)) return;
  gallery.querySelectorAll('[data-gallery-image]').forEach((image) => {
    image.classList.toggle('is-selected', image.dataset.galleryImage === id);
  });
  gallery.querySelectorAll('[data-gallery-select]').forEach((button) => {
    button.setAttribute('aria-pressed', String(button.dataset.gallerySelect === id));
  });
}

function initializeGalleries(scope = document) {
  scope.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const first = gallery.querySelector('[data-gallery-first]');
    if (!first) return;
    selectGalleryImage(gallery, first.dataset.galleryImage);
    gallery.classList.add('js-gallery');
  });
}
initializeGalleries();
document.addEventListener('shopify:section:load', (event) => initializeGalleries(event.target));

// Never hide the primary photo until the alternate has actually loaded.
function initializeProductCards(scope = document) {
  scope.querySelectorAll('.product-card__link--has-alternate').forEach((link) => {
    const alternate = link.querySelector('.product-card__image--alternate');
    if (!alternate) return;
    const update = () => link.classList.toggle('product-card__link--alternate-ready', alternate.complete && alternate.naturalWidth > 0);
    alternate.addEventListener('load', update, { once: true });
    alternate.addEventListener('error', () => link.classList.remove('product-card__link--alternate-ready'), { once: true });
    update();
  });
}
initializeProductCards();
document.addEventListener('shopify:section:load', (event) => initializeProductCards(event.target));

function setFilters(open) {
  const panel = document.querySelector('[data-filter-panel]');
  const toggle = document.querySelector('[data-filter-toggle]');
  if (!panel || !toggle) return;
  panel.classList.toggle('is-open', open);
  toggle.setAttribute('aria-expanded', String(open));
  if (open) panel.querySelector('[data-filter-close]')?.focus();
  else if (window.matchMedia('(max-width: 820px)').matches) toggle.focus();
}

// Keep disclosure menus usable with touch, keyboard and Shopify editor reloads.
document.addEventListener('toggle', (event) => {
  if (!event.target.matches?.('.nav-category') || !event.target.open) return;
  const navigation = event.target.closest('nav');
  navigation?.querySelectorAll('.nav-category[open]').forEach((item) => {
    if (item !== event.target) item.open = false;
  });
}, true);
document.addEventListener('click', (event) => {
  if (!event.target.closest('.nav-category')) {
    document.querySelectorAll('.nav-category[open]').forEach((item) => { item.open = false; });
  }
});

function setDrawer(open, trigger) {
  const drawer = document.querySelector('[data-cart-drawer]');
  const scrim = document.querySelector('[data-cart-close].drawer-scrim');
  if (!drawer || !scrim) return;
  if (open && trigger) drawerTrigger = trigger;
  drawer.classList.toggle('is-open', open);
  drawer.setAttribute('aria-hidden', String(!open));
  if (open) drawer.removeAttribute('inert');
  else drawer.setAttribute('inert', '');
  scrim.hidden = !open;
  document.body.classList.toggle('drawer-open', open);
  if (open) drawer.querySelector('[data-cart-close]')?.focus();
  else if (drawerTrigger instanceof HTMLElement) {
    drawerTrigger.focus();
    drawerTrigger = null;
  }
}

async function refreshCartDrawer() {
  const response = await fetch(`${rootPath}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Korpa se trenutno ne može osvježiti.');
  const sections = await response.json();
  const holder = document.createElement('div');
  holder.innerHTML = sections['cart-drawer'] || '';
  const incoming = holder.querySelector('[data-cart-drawer]');
  const current = document.querySelector('[data-cart-drawer]');
  if (incoming && current) current.replaceWith(incoming);
  const count = incoming?.dataset.cartCount || '0';
  // The drawer also carries data-cart-count as metadata; never replace its content.
  document.querySelectorAll('[data-cart-count]:not([data-cart-drawer])').forEach((item) => { item.textContent = count; });
  document.querySelectorAll('[data-cart-open]').forEach((button) => {
    button.setAttribute('aria-label', `Otvori korpu, ${count} artikala`);
  });
}

document.addEventListener('click', (event) => {
  const menuToggle = event.target.closest('[data-menu-toggle]');
  if (menuToggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const expanded = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!expanded));
    if (menu) menu.hidden = expanded;
  }
  const cartTrigger = event.target.closest('[data-cart-open]');
  if (cartTrigger) setDrawer(true, cartTrigger);
  if (event.target.closest('[data-cart-close]')) setDrawer(false);
  const filterToggle = event.target.closest('[data-filter-toggle]');
  if (filterToggle) setFilters(filterToggle.getAttribute('aria-expanded') !== 'true');
  if (event.target.closest('[data-filter-close]')) setFilters(false);
  const thumbnail = event.target.closest('[data-gallery-select]');
  if (thumbnail) selectGalleryImage(thumbnail.closest('[data-product-gallery]'), thumbnail.dataset.gallerySelect);
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    setDrawer(false);
    if (document.querySelector('[data-filter-panel].is-open')) setFilters(false);
    const menu = document.querySelector('[data-mobile-menu]');
    const menuToggle = document.querySelector('[data-menu-toggle]');
    if (menu) menu.hidden = true;
    if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
    document.querySelectorAll('.nav-category[open], .search-popover[open]').forEach((item) => item.removeAttribute('open'));
  }
  if (event.key === 'Tab') {
    const drawer = document.querySelector('[data-cart-drawer].is-open') || (window.matchMedia('(max-width: 820px)').matches && document.querySelector('[data-filter-panel].is-open'));
    if (!drawer) return;
    const focusable = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  const container = select.closest('[data-product]');
  const price = container?.querySelector('[data-price]');
  const variantInput = container?.querySelector('input[name="id"]');
  const button = container?.querySelector('[data-add-button]');
  if (price) price.textContent = option?.dataset.price || '';
  if (variantInput) variantInput.value = select.value;
  const quantity = container?.querySelector('input[name="quantity"]');
  if (quantity) {
    if (option?.dataset.stockLimit !== '') {
      quantity.max = option.dataset.stockLimit;
      if (Number(quantity.value) > Number(quantity.max)) quantity.value = String(Math.max(1, Number(quantity.max)));
    } else quantity.removeAttribute('max');
  }
  const sku = container?.querySelector('[data-product-sku]');
  if (sku) { sku.textContent = option?.dataset.sku || ''; sku.parentElement.hidden = !option?.dataset.sku; }
  const availability = container?.querySelector('[data-product-availability]');
  if (availability) {
    const available = option?.dataset.available === 'true';
    availability.textContent = available ? 'Na stanju' : 'Trenutno nije na stanju';
    availability.classList.toggle('is-available', available);
  }
  if (button) {
    const available = option?.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.addLabel : button.dataset.soldLabel;
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[data-ajax-cart]');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[data-add-button]');
  const original = button?.textContent;
  const statusMessage = form.querySelector('[data-product-message]');
  if (statusMessage) statusMessage.textContent = '';
  if (button) { button.disabled = true; button.textContent = button.dataset.loadingLabel || 'Dodavanje…'; }
  try {
    const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error(response.status === 422 ? 'Tražena količina trenutno nije dostupna. Provjerite i količinu koja je već u korpi.' : 'Proizvod nije moguće dodati u korpu. Pokušajte ponovo.');
    await refreshCartDrawer();
    setDrawer(true, button);
  } catch (error) {
    const message = form.querySelector('[data-product-message]');
    if (message) message.textContent = error.message;
  } finally {
    if (button && document.contains(button)) { button.disabled = false; button.textContent = original; }
  }
});

document.querySelectorAll('[data-recommendations-url]').forEach(async (element) => {
  try {
    const response = await fetch(element.dataset.recommendationsUrl);
    if (!response.ok) return;
    const page = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = page.querySelector('[data-recommendations-content]');
    if (content?.children.length) { element.replaceChildren(content); initializeProductCards(element); }
  } catch (_) {}
});

const revealItems = document.querySelectorAll('.reveal');
if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  }), { rootMargin: '0px 0px -8% 0px', threshold: .08 });
  revealItems.forEach((item) => observer.observe(item));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('.reveal').forEach((item) => observer.observe(item)));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}
